(() => {
  if (customElements.get('brand-loop-carousel')) return;
class BrandLoopCarousel extends HTMLElement {
  async connectedCallback() {
    this.abort?.abort();
    const abort = this.abort = new AbortController();
    await customElements.whenDefined('scroll-carousel');
    if (abort.signal.aborted || !this.isConnected) return;
    this.track = this.querySelector('scroll-carousel');
    this.originals = [...this.track.children];
    this.count = this.originals.length;
    if (this.count < 2) return;
    for (const original of this.originals) {
      const clone = original.cloneNode(true);
      clone.dataset.loopClone = '';
      clone.setAttribute('aria-hidden', 'true');
      for (const node of [clone, ...clone.querySelectorAll('*')]) {
        node.removeAttribute('id');
        node.removeAttribute('data-shopify-editor-block');
        if (node.matches('a, button, input, select, textarea, [tabindex]')) node.tabIndex = -1;
      }
      this.track.append(clone);
    }
    const signal = abort.signal;
    this.visible = false;
    this.hovered = false;
    this.focused = false;
    this.editing = false;
    this.cooldown = 0;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.track.addEventListener('carousel:settle', () => {
      if (this.track.selectedIndex >= this.count) this.track.select(this.track.selectedIndex % this.count, { instant: true });
    }, { signal });
    this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; }, { signal });
    this.addEventListener('pointerleave', () => { this.hovered = false; }, { signal });
    this.addEventListener('focusin', e => { this.focused = true; }, { signal });
    this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); }, { signal });
    this.track.addEventListener('pointerdown', () => { this.cooldown = Date.now() + 8000; }, { signal });
    this.track.addEventListener('wheel', () => { this.cooldown = Date.now() + 8000; }, { signal, passive: true });
    this.track.addEventListener('keydown', e => {
      if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      e.preventDefault();
      const direction = (e.key === 'ArrowRight' ? 1 : -1) * (document.dir === 'rtl' ? -1 : 1);
      const next = this.track.selectedIndex + direction;
      if (next < 0) this.track.select(this.count - 1);
      else this.track.select(next);
    }, { signal });
    this.addEventListener('shopify:block:select', () => { this.editing = true; }, { signal });
    this.addEventListener('shopify:block:deselect', () => { this.editing = false; }, { signal });
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
    this.observer.observe(this);
    this.timer = setInterval(() => this.advance(), Math.max(2000, Number(this.getAttribute('interval')) || 3000));
  }
  advance() {
    if (!this.hasAttribute('autoplay') || this.hovered || this.focused || this.editing || !this.visible || document.hidden || this.motion.matches || Date.now() < this.cooldown) return;
    this.track.select(this.track.selectedIndex + 1);
  }
  disconnectedCallback() {
    this.abort?.abort();
    clearInterval(this.timer);
    this.observer?.disconnect();
    this.querySelectorAll('[data-loop-clone]').forEach(el => el.remove());
  }
}
customElements.define('brand-loop-carousel', BrandLoopCarousel);
})();
